import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SelectButton } from 'primeng/selectbutton';
import { MixedChartDateRangeInterface, TimeRangeKey } from '../../../types/interfaces/charts.interface';
import { InputCalendarInterface } from '../../../types/interfaces/input.interface';
import { InputCalendarComponent } from '../calendar/calendar.component';

@Component({
  selector: 'app-time-range-selector',
  standalone: true,
  imports: [
    SelectButton,
    FormsModule,
    InputCalendarComponent,
  ],
  templateUrl: './time-range-selector.component.html',
  styleUrl: './time-range-selector.component.css',
})
export class TimeRangeSelectorComponent implements OnInit {
  @Output()
  public rangeSelected: EventEmitter<MixedChartDateRangeInterface> =
    new EventEmitter<MixedChartDateRangeInterface>();

  public isCalendarOpen: boolean = false;

  public chartRange: TimeRangeKey = '1W';

  public rangeOptions: TimeRangeKey[] = [
    '1H',
    '1D',
    '1W',
    '1M',
    'Ben.',
  ];

  public selectedRange: Date[] | null = null;

  public chartDateRangeConfig: InputCalendarInterface = {
    id: 'chart-date-range',
    label: 'Zeitraum',
    placeholder: '',
    selectionMode: 'range',
    showIcon: true,
    size: 'small',
    appendTo: 'body',
    baseZIndex: 10000,
  };

  public ngOnInit(): void {
    this.updateChartRange();
  }

  public updateChartRange(): void {
    this.isCalendarOpen = this.chartRange === 'Ben.';

    let to: Date = new Date();
    let from: Date = new Date(to);

    switch (this.chartRange) {
      case '1H':
        from.setMinutes(from.getMinutes() - 60);
        break;

      case '1D':
        from.setDate(from.getDate() - 1);
        break;

      case '1W':
        from.setDate(from.getDate() - 7);
        break;

      case '1M':
        from.setMonth(from.getMonth() - 1);
        break;

      case 'Ben.':
        if (!this.selectedRange || this.selectedRange.length !== 2) return;
        if (!this.selectedRange[0] || !this.selectedRange[1]) return;

        from = this._getStartOfDay(this.selectedRange[0]);
        to = this._getEndOfDay(this.selectedRange[1]);
        break;

      default:
        from.setDate(from.getDate() - 7);
        break;
    }

    this.rangeSelected.emit({
      from,
      to,
      type: this.chartRange,
    });
  }

  private _getStartOfDay(date: Date): Date {
    const startDate: Date = new Date(date);

    startDate.setHours(0, 0, 0, 0);

    return startDate;
  }

  private _getEndOfDay(date: Date): Date {
    const endDate: Date = new Date(date);

    endDate.setHours(23, 59, 59, 999);

    return endDate;
  }
}